class ProductCartHandler {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener("click", event => {
      const btn = event.target.closest(".product-card__add-to-cart-btn .product-card__button");
      if (!btn) return;

      event.preventDefault();
      this.handleAddToCart({ currentTarget: btn });
    });
  }

  async handleAddToCart(event) {
    const btn = event.currentTarget;
    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle;
    const productImage = btn.dataset.productImage;
    const loadingEl = btn.closest(".product-card__add-to-cart-btn")?.querySelector(".loading");
    const countEL = btn.closest(".product-card__add-to-cart-btn")?.querySelector(".product-card__count");

    if (!variantId || btn.disabled) return;

    loadingEl?.classList.add("active");
    btn.disabled = true;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error("Add to cart failed");

      // ✅ Update cart bubble + drawer
      await this.updateCartCount();
      await this.refreshCartDrawer();

      // this.openCartDrawer();
      this.showATCToast(productTitle, productImage);

      this.showMessage(`${productTitle} added to cart successfully!`);
    } catch {
      this.showMessage("Failed to add product to cart. Please try again.", true);
    } finally {
      btn.disabled = false;
      loadingEl?.classList.remove("active");

      const qty = await this.updateCartCount(variantId);
      if (countEL) {
        countEL.innerHTML = qty;
        countEL.classList.remove("empty");
      }
    }
  }

  // ✅ Update cart count bubble (now robust and safe)
  async updateCartCount(variantId) {
    try {
      const cart = await (await fetch("/cart.js")).json();

      this.updateCartCountBubble(cart); // use safe method below

      // Dispatch global update event
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

      // ✅ Return quantity for specific variant (if needed)
      if (variantId) {
        const item = cart.items.find(i => i.id == variantId);
        return item ? item.quantity : 0;
      }

      return cart;
    } catch (err) {
      console.error("Error updating cart count:", err);
      return null;
    }
  }

  showATCToast(title, image) {
    // Create clone
    const toast = document.createElement("div");
    toast.className = "atc-toast show";

    toast.innerHTML = `
      <img class="atc-toast-image" src="${image}">
      <div class="info-wrapper">
        <span class="atc-toast-title">${title}</span>
        <span class="atc-toast-caption">
          Added to cart 
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
            <path d="M6.91795 0.474425L2.43815 4.91854C2.41214 4.94436 2.38126 4.96485 2.34727 4.97883C2.31328 4.99281 2.27685 5 2.24006 5C2.20326 5 2.16683 4.99281 2.13284 4.97883C2.09885 4.96485 2.06797 4.94436 2.04196 4.91854L0.082052 2.97424C0.029515 2.92212 0 2.85143 0 2.77772C0 2.70402 0.029515 2.63333 0.082052 2.58121C0.134589 2.52909 0.205845 2.49981 0.280143 2.49981C0.354442 2.49981 0.425697 2.52909 0.478234 2.58121L2.24006 4.32935L6.52176 0.0813982C6.5743 0.0292797 6.64556 -5.49157e-10 6.71986 0C6.79415 5.49158e-10 6.86541 0.0292797 6.91795 0.0813982C6.97048 0.133517 7 0.204205 7 0.277911C7 0.351618 6.97048 0.422306 6.91795 0.474425Z" fill="#F9F7F3"/>
          </svg>
        </span>
      </div>
      <button class="atc-toast-close">
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
          <path d="M5.91209 5.48761C5.93996 5.51548 5.96207 5.54857 5.97715 5.58499C5.99224 5.6214 6 5.66043 6 5.69985C6 5.73927 5.99224 5.7783 5.97715 5.81471C5.96207 5.85113 5.93996 5.88422 5.91209 5.91209C5.88422 5.93996 5.85113 5.96207 5.81471 5.97715C5.7783 5.99224 5.73927 6 5.69985 6C5.66043 6 5.6214 5.99224 5.58499 5.97715C5.54857 5.96207 5.51548 5.93996 5.48761 5.91209L3 3.4241L0.512388 5.91209C0.456099 5.96838 0.379755 6 0.30015 6C0.220545 6 0.144201 5.96838 0.0879119 5.91209C0.0316228 5.8558 1.5692e-09 5.77945 0 5.69985C-1.5692e-09 5.62024 0.0316228 5.5439 0.0879119 5.48761L2.5759 3L0.0879119 0.512388C0.0316228 0.456099 0 0.379755 0 0.30015C0 0.220545 0.0316228 0.144201 0.0879119 0.0879119C0.144201 0.0316228 0.220545 0 0.30015 0C0.379755 0 0.456099 0.0316228 0.512388 0.0879119L3 2.5759L5.48761 0.0879119C5.5439 0.0316228 5.62024 -1.5692e-09 5.69985 0C5.77945 1.5692e-09 5.8558 0.0316228 5.91209 0.0879119C5.96838 0.144201 6 0.220545 6 0.30015C6 0.379755 5.96838 0.456099 5.91209 0.512388L3.4241 3L5.91209 5.48761Z" fill="white"/>
        </svg>
      </button>
    `;

    // Append into container
    const container = document.getElementById("atc-toast-container");
    if (!container) return console.warn("Missing #atc-toast-container");
    container.appendChild(toast);

    // --- Close button logic ---
    toast.querySelector(".atc-toast-close").addEventListener("click", () => {
      toast.classList.remove("show");
      setTimeout(() => toast.remove(), 300);
    });

    // --- Auto-remove after 3 seconds ---
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => toast.remove(), 300);
    }, 7000);
  }


  // ✅ Safe reusable bubble updater (no errors if missing)
  updateCartCountBubble(cart) {
    const container = document.querySelector("#cart-icon-bubble");
    if (!container) return;

    // find or create .cart-count-bubble
    let bubble = container.querySelector(".cart-count-bubble");
    if (!bubble) {
      bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      container.appendChild(bubble);
    }

    // find or create <span>
    let span = bubble.querySelector("span");
    if (!span) {
      span = document.createElement("span");
      bubble.appendChild(span);
    }

    // update the count
    const count = cart?.item_count ?? 0;
    span.dataset.cartCount = count;
    span.textContent = count;

    // show/hide bubble based on count
    bubble.style.display = count > 0 ? "" : "none";
  }

  // ✅ Refresh drawer and also update bubble
  async refreshCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer, [id*='cart-drawer'], [class*='cart-drawer']");
    if (!cartDrawer) return;

    try {
      const res = await fetch("/cart?section_id=cart-drawer");
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newInner = doc.querySelector(".drawer__inner, .cart-drawer__content, [data-cart-drawer-content]");
      const currentInner = cartDrawer.querySelector(".drawer__inner, .cart-drawer__content, [data-cart-drawer-content]");

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
        cartDrawer.classList.remove("is-empty");
        customElements?.upgrade?.(cartDrawer);
      }

      // 🧩 Also update bubble after refresh (reuse existing method)
      const cartData = await (await fetch("/cart.js")).json();
      this.updateCartCountBubble(cartData);

    } catch (err) {
      console.error("Error refreshing cart drawer:", err);
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;
    if (typeof cartDrawer.open === "function") {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add("is-open", "active", "open");
      document.body.classList.add("overflow-hidden");
    }
  }

  showMessage(msg, isError = false) {
    isError ? console.error(msg) : console.log(msg);
  }
}

if (!window.productCartHandler) {
  window.productCartHandler = new ProductCartHandler();
}


document.addEventListener("click", event => {
  const button = event.target.closest(".product-type-button");
  if (!button) return;

  const card = button.closest(".product-card");
  if (!card) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = button.dataset.handel;
  const buttons = card.querySelectorAll(".product-type-button");
  const wrappers = card.querySelectorAll(".product-card__wrapper");
  const matchedWrapper = Array.from(wrappers).find(wrapper => wrapper.dataset.handel === handle);

  buttons.forEach(item => item.classList.toggle("active", item === button));
  wrappers.forEach(wrapper => wrapper.classList.toggle("active", wrapper === matchedWrapper));
});

window.productCardInteractionsReady = true;
document.documentElement.classList.add("product-card-interactions-ready");
document.dispatchEvent(new CustomEvent("product-card:ready"));

document.addEventListener('DOMContentLoaded', () => {
  // Function to update product cards based on current cart state
  function updateProductCards(cart) {
    const cartItems = cart.items || [];

    // Loop through all product cards on the page
    document.querySelectorAll('.product-card[data-product-id]').forEach(card => {
      const productId = card.getAttribute('data-product-id');
      const addBtn = card.querySelector('[data-add-to-cart], .product-card__add-to-cart-btn, button[type="submit"]');
      const qtyBadge = card.querySelector('.product-in-cart-qty');

      // Find matching product in the cart
      const item = cartItems.find(item => item.product_id == productId);

      if (item) {
        // Product is in cart
        card.classList.add('in-cart');
        if (addBtn) {
          addBtn.disabled = true;
        }

        // Optional quantity badge
        if (qtyBadge) {
          qtyBadge.textContent = `${item.quantity}`;
        } else {
          const span = document.createElement('span');
          span.className = 'product-in-cart-qty';
          span.textContent = `${item.quantity}`;
        }
      } else {
        // Product not in cart
        card.classList.remove('in-cart');
        if (addBtn) {
          addBtn.disabled = false;
        }
        if (qtyBadge) qtyBadge.remove();
      }
    });
  }

  // Function to fetch latest cart
  async function fetchCartAndUpdateCards() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateProductCards(cart);
    } catch (err) {
      console.error('Error updating product cards:', err);
    }
  }

  // Update on page load
  fetchCartAndUpdateCards();

  // Re-run whenever the cart changes (Dawn events)
  document.addEventListener('cart:refresh', fetchCartAndUpdateCards);
  document.addEventListener('cart:updated', fetchCartAndUpdateCards);

  // Also hook into AJAX form submits (add/remove)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (form) {
      setTimeout(fetchCartAndUpdateCards, 800);
    }
  });

  // For cart drawer remove/update buttons (delegated)
  document.body.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-remove], .cart-remove-button, .quantity__button')) {
      setTimeout(fetchCartAndUpdateCards, 800);
    }
  });
});

// Intercept fetch requests globally
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  // Detect cart updates (add/change/update endpoints)
  const [url] = args;
  if (typeof url === 'string' && (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update')
  )) {
    response.clone().json().then(cart => {
      if (cart && cart.items) updateProductCardCounts(cart);
    }).catch(() => {});
  }

  return response;
};

// === Function: Update product card counts ===
function updateProductCardCounts(cart) {
  // Build a map of product_id -> total quantity
  const productQuantities = {};
  cart.items.forEach(item => {
    productQuantities[item.product_id] = 
      (productQuantities[item.product_id] || 0) + item.quantity;
  });

  // Loop through all product cards in DOM
  document.querySelectorAll('.product-card[data-product-id]').forEach(card => {
    const productId = Number(card.dataset.productId);
    const countEl = card.querySelector('.product-card__count');
    if (!countEl) return;

    const qty = productQuantities[productId] || 0;
    countEl.textContent = qty;

    // Update state classes
    if (qty > 0) {
      countEl.classList.remove('empty');
    } else {
      countEl.classList.add('empty');
    }

    // Optional UI feedback
    card.classList.toggle('in-cart', qty > 0);
  });
}
